import { __assign } from "tslib";
import { monitor, noop, runOnReadyState } from '@datadog/browser-core';
import { LifeCycleEventType, makeRumPublicApi, } from '@datadog/browser-rum-core';
export function makeRumRecorderPublicApi(startRumImpl, startRecordingImpl) {
    var onRumStartStrategy = function (initConfiguration, configuration) {
        if (!initConfiguration.manualSessionReplayRecordingStart &&
            // TODO: remove this when no snippets without manualSessionReplayRecordingStart are served in
            // the Datadog app. See RUMF-886
            !configuration.isEnabled('postpone_start_recording')) {
            startSessionReplayRecordingStrategy();
        }
    };
    var startSessionReplayRecordingStrategy = function () {
        onRumStartStrategy = function () { return startSessionReplayRecordingStrategy(); };
    };
    var stopSessionReplayRecordingStrategy = function () {
        onRumStartStrategy = noop;
    };
    function startRumRecorder(initConfiguration, configuration, internalMonitoring, getCommonContext, initialViewName) {
        var state = {
            status: 0 /* Stopped */,
        };
        var startRumResult = startRumImpl(initConfiguration, configuration, internalMonitoring, function () { return (__assign(__assign({}, getCommonContext()), { hasReplay: state.status === 2 /* Started */ ? true : undefined })); }, initialViewName);
        var lifeCycle = startRumResult.lifeCycle, parentContexts = startRumResult.parentContexts, session = startRumResult.session;
        startSessionReplayRecordingStrategy = function () {
            if (state.status !== 0 /* Stopped */) {
                return;
            }
            state = { status: 1 /* Starting */ };
            runOnReadyState('complete', function () {
                if (state.status !== 1 /* Starting */) {
                    return;
                }
                var stopRecording = startRecordingImpl(lifeCycle, initConfiguration.applicationId, configuration, session, parentContexts).stop;
                state = {
                    status: 2 /* Started */,
                    stopRecording: stopRecording,
                };
                lifeCycle.notify(LifeCycleEventType.RECORD_STARTED);
            });
        };
        stopSessionReplayRecordingStrategy = function () {
            if (state.status === 0 /* Stopped */) {
                return;
            }
            if (state.status === 2 /* Started */) {
                state.stopRecording();
            }
            state = {
                status: 0 /* Stopped */,
            };
            lifeCycle.notify(LifeCycleEventType.RECORD_STOPPED);
        };
        onRumStartStrategy(initConfiguration, configuration);
        return startRumResult;
    }
    var rumPublicApi = makeRumPublicApi(startRumRecorder);
    var rumRecorderPublicApi = __assign(__assign({}, rumPublicApi), { startSessionReplayRecording: monitor(function () {
            startSessionReplayRecordingStrategy();
        }), stopSessionReplayRecording: monitor(function () {
            stopSessionReplayRecordingStrategy();
        }) });
    return rumRecorderPublicApi;
}
//# sourceMappingURL=rumRecorderPublicApi.js.map